import api from "APP_ROOT/api";
import { get, isEmpty } from "lodash";
import { SUCCESS } from "LIB/submission/constants";
import { VENDOR_RMA_NUMBER } from "MODULES/RMAsAndWarranties/constants";
import { toastr } from "react-redux-toastr";
import * as actionTypes from "./actionTypes";
import pagination from "./pagination";

export function set(rma) {
  return { type: actionTypes.SET, rma };
}

export function fetch(id) {
  return dispatch => api.rmas.show(id).then(({ data }) => dispatch(set(data)));
}

export const { search, setFilter, pageActions } = pagination;

export function sync() {
  return (dispatch, getState) => {
    const id = getState().rmaDetail.getIn(["rma", "id"]);
    return api.rmas
      .sync(id)
      .then(() => {
        toastr.success("SUCCESS", "Successfully Synced.");

        return SUCCESS;
      })
      .catch(() => {
        toastr.error("ERROR", "Sync Failed");
      });
  };
}

export function update(data, setForceOpenShipTo) {
  return (dispatch, getState) => {
    const id = getState().rmaDetail.getIn(["rma", "id"]);
    const updatedVendorRmaNumber =
      isEmpty(getState().rmaDetail.getIn(["rma", VENDOR_RMA_NUMBER])) &&
      !isEmpty(data[VENDOR_RMA_NUMBER]);
    return api.rmas.update(id, data).then(({ data: rma }) => {
      dispatch(set(rma));
      if (updatedVendorRmaNumber && setForceOpenShipTo) {
        setForceOpenShipTo(true);
      }
      return SUCCESS;
    });
  };
}

export function download(data, url) {
  return (dispatch, getState) => {
    const id = getState().rmaDetail.getIn(["rma", "id"]);
    return api.rmas.update(id, data).then(({ data: rma }) => {
      dispatch(set(rma));
      window.location.assign(url);
      return SUCCESS;
    });
  };
}

export function cancelVendorRma() {
  return (dispatch, getState) => {
    const id = getState().rmaDetail.getIn(["rma", "id"]);
    return api.vendorRmas.cancel(id).then(({ data }) => {
      dispatch(set(data));
      return SUCCESS;
    });
  };
}

export function cancelCustomerRma() {
  return (dispatch, getState) => {
    const id = getState().rmaDetail.getIn(["rma", "id"]);
    return api.customerRmas
      .cancel(id)
      .then(({ data }) => {
        dispatch(set(data));
        return SUCCESS;
      })
      .catch(err => {
        toastr.error("Error", get(err, "errors.base", []).join(","));
      });
  };
}

export function vendorRmaUpdate(data, setForceOpenShipTo) {
  return (dispatch, getState) => {
    const id = getState().rmaDetail.getIn(["rma", "id"]);
    const updatedVendorRmaNumber =
      isEmpty(getState().rmaDetail.getIn(["rma", VENDOR_RMA_NUMBER])) &&
      !isEmpty(data[VENDOR_RMA_NUMBER]);
    return api.vendorRmas.update(id, data).then(({ data: rma }) => {
      dispatch(set(rma));
      if (updatedVendorRmaNumber && setForceOpenShipTo) {
        setForceOpenShipTo(true);
      }
      return SUCCESS;
    });
  };
}



// WEBPACK FOOTER //
// ./app/modules/RMAsAndWarranties/actions.js